<template>
  <metadata-node-wrapper v-if="item" :level="item.level" :header="item.label">
    <b-table striped hover v-if="item.elementsAsTable"
      :fields="item.elementsAsTable.fields"
      :items="item.elementsAsTable.items">
      <template v-for="field in item.elementsAsTable.fields.map(x => x.key)" v-slot:cell()="data">
        <metadata-node :item="data.value" :key="field" v-if="data.value"/>
      </template>
    </b-table>
    <template v-else-if="item.elementsAsList">
      <b v-if="item.listLabel">{{item.listLabel}}</b>
      <ul>
        <li v-for="(value, index) in item.elementsAsList" :key="index">
          <metadata-node :item="value"/>
        </li>
      </ul>
    </template>
    <template v-else-if="item.elements">
      <template v-for="(item, index) in item.elements">
        <metadata-node :item="item" :key="index"/>
      </template>
    </template>
    <span v-else>{{item.value}}</span>
  </metadata-node-wrapper>
</template>

<script>
import MetadataNodeWrapper from "./MetadataNodeWrapper";

export default {
  name: "MetadataNode",
  components: {
    MetadataNodeWrapper
  },
  props: {
    item: Object
  }
};
</script>